import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { ListBox } from 'primereact/listbox';
import PropTypes from 'prop-types';
import usePlacesAutocomplete, { getDetails, getGeocode } from "use-places-autocomplete";
import { I18n } from 'aws-amplify';
import { useHookstate } from '@hookstate/core';
import { currentInstallation } from './ScrbTools';
import { FloatLabel } from 'primereact/floatlabel';
import classNames from 'classnames';

AdresseAutoComplete.propTypes = {
    setFoundAdress: PropTypes.func.isRequired,
    scope: PropTypes.string,
    disabled: PropTypes.bool,
    componentRestrictions: PropTypes.object.isRequired
};

function AdresseAutoComplete(props) {
    const cacheKey = `address-${Array.isArray(props.componentRestrictions.country)
        ? props.componentRestrictions.country.sort().join('-')
        : props.componentRestrictions.country.toLowerCase()}`;

    const { value, suggestions: { status, data }, setValue, clearSuggestions } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: props.componentRestrictions
        },
        debounce: 250,
        initOnMount: true,
        cacheKey,
    });
    const installation = useHookstate(currentInstallation);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (installation.get()[props.scope].street) {
            const street = installation.get()[props.scope].number ? installation.get()[props.scope].number + " " + installation.get()[props.scope].street : installation.get()[props.scope].street;
            setValue(street);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (e) => {
        setValue(e.target.value);
        installation[props.scope].raw.set(e.target.value);
    };

    const selectAdress = (description) => {
        setValue(description, false);
        clearSuggestions();
        getGeocode({ address: description }).then((results) => {
            getDetails({ placeId: results[0].place_id }).then((details) => {
                props.setFoundAdress({
                    adress: description,
                    details: details['address_components']
                });
            })
        });
    };

    return (
        <div>
            <FloatLabel>
                <InputText
                    name="address"
                    value={value}
                    onChange={onChange}
                    autoComplete="off"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => {
                        setTimeout(() => setIsFocused(false), 200);
                    }}
                    className={classNames("w-full", { "p-invalid": !value })}
                    disabled={props.disabled}
                    tooltip={I18n.get("addressTooltip")}
                    tooltipOptions={{ position: 'top' }}
                />
                <label htmlFor="address">{I18n.get("address")}</label>
            </FloatLabel>
            {status === "OK" && isFocused && (
                <ListBox
                    value={value}
                    options={data}
                    onChange={(suggestion) => selectAdress(suggestion.value.description)}
                    optionLabel="description"
                    disabled={props.disabled}
                />
            )}
        </div>
    );
};
export default AdresseAutoComplete;